import React from 'react';
import { Navigate, Route, Routes, BrowserRouter } from 'react-router-dom';
import { Container } from '@mantine/core';

import DashboardPage from '@/pages/Dashboard.page';
import LogoutPage from '@/pages/Logout.page';
import LoginPage from '@/pages/Login.page/Login.page';
import AuthCompletePage from '@/pages/AuthComplete.page';
import EventPage from '@/pages/Event.page';
import ManifestsPage from '@/pages/Manifests.page';
import ReportPage from '@/pages/Report.page';
import ForgotPasswordEmailPage from '@/pages/ForgotPassword.page/ForgotPasswordEmail.page';
import ForgotPasswordResetPage from '@/pages/ForgotPassword.page/ForgotPasswordReset.page';
import PrivateRoute from './PrivateRoute';
import CalendarPage from '@/pages/Calendar.page';
import AvailabilityPage from '@/pages/Availability.page';
import { MenusPage } from '@/pages/Menus.page';
import AvailabilityPermissionRoute from './AvailabilityPermissionRoute';
import MenusPermissionRoute from './MenusPermissionRoute';
import { Page, RequireAccess } from '@/permissions';
import { ROUTES } from '@/constants';
import AuthErrorWatcher from './AuthErrorWatcher';

const Router: React.FC = () => (
  <Container fluid>
    <BrowserRouter>
      <AuthErrorWatcher />
      <Routes>
        <Route path={ROUTES.manifests} element={<ManifestsPage />} />
        <Route path={ROUTES.login} element={<LoginPage />} />
        <Route path={ROUTES.logout} element={<LogoutPage />} />
        <Route path={ROUTES.authComplete} element={<AuthCompletePage />} />
        <Route path={ROUTES.forgotPasswordEmail} element={<ForgotPasswordEmailPage />} />
        <Route path={ROUTES.forgotPasswordReset} element={<ForgotPasswordResetPage />} />
        <Route path={ROUTES.root} element={<Navigate to={ROUTES[Page.Dashboard]} />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Routes>
                <Route path={`${ROUTES[Page.Dashboard]}/*`} element={<DashboardPage />}>
                  <Route path=":type/:id" element={<EventPage />} />
                </Route>
                <Route
                  path={`${ROUTES[Page.Calendar]}/*`}
                  element={
                    <RequireAccess page={Page.Calendar}>
                      <CalendarPage />
                    </RequireAccess>
                  }
                >
                  <Route path=":type/:id" element={<EventPage />} />
                </Route>

                <Route
                  path={ROUTES[Page.Availability]}
                  element={
                    <AvailabilityPermissionRoute>
                      <AvailabilityPage />
                    </AvailabilityPermissionRoute>
                  }
                />

                <Route
                  path={ROUTES[Page.Menus]}
                  element={
                    <MenusPermissionRoute>
                      <MenusPage />
                    </MenusPermissionRoute>
                  }
                />

                <Route
                  path={ROUTES[Page.Reports]}
                  element={
                    <RequireAccess page={Page.Reports}>
                      <ReportPage />
                    </RequireAccess>
                  }
                />
                <Route path="*" element={<Navigate to={ROUTES[Page.Dashboard]} replace />} />
              </Routes>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  </Container>
);

export default Router;
